import React from "react";
import { useTranslation } from "react-i18next";

const SkipLink = () => {
  const { t } = useTranslation();
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:bg-cfSecondary focus:text-cfPrimaryDarkBlue focus:px-4 focus:py-2 focus:rounded-md focus:shadow-lg"
    >
      {t("skip_to_main_content", "Skip to main content")}
    </a>
  );
};

export default SkipLink;
